import React from "react";
import { Typography, Button, Box, Stack } from "@mui/material";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        maxWidth: 800,
        mx: "auto",
        px: 4,
        py: 8,
      }}
    >
      <Typography
        variant="h2"
        component="h1"
        sx={{
          fontWeight: 700,
          mb: 3,
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
        }}
      >
        Trainer App <br /> Start coaching
      </Typography>

      <Typography
        variant="h5"
        component="h2"
        sx={{
          mb: 4,
          color: "text.secondary",
          fontWeight: 400,
          fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
          lineHeight: 1.6,
        }}
      >
        Programming, messaging, content, and payments — all in one place.
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 6,
          color: "text.secondary",
          fontSize: { xs: "0.95rem", sm: "1rem" },
        }}
      >
        Manage your entire coaching business in one place. Your first client is
        free so you can try out the platform.
      </Typography>

      <Typography
        variant="h6"
        sx={{
          mb: 6,
          color: "text.secondary",
          fontSize: { xs: "0.95rem", sm: "1rem", textDecoration: "underline" },
        }}
      >
        First month is free. Cancel anytime.
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <Button
          variant="contained"
          component={Link}
          to="/coaching"
          size="large"
          sx={{
            px: 4,
            py: 1.5,
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          Start Coaching
        </Button>
        <Button
          variant="outlined"
          component={Link}
          to="/pricing"
          size="large"
          sx={{
            px: 4,
            py: 1.5,
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          Pricing
        </Button>
      </Stack>
    </Box>
  );
};

export default Home;
